import { Stack, useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

import { StoreLocatorServiceModeTab } from '@fhs/store-locator';
import { VisuallyHiddenH1 } from '@fhs/ui';
import { StoreLocator } from '@fhs-legacy/frontend/src/pages/store-locator';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

import { useForwardToStoreLocator } from '../../utils/use-forward-to-store-locator';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

/**
 * The legacy pickup URL. The v2 locator lives on `/store-locator`, so with it on this page
 * forwards there on the pickup tab.
 */
function StoreLocatorPage() {
  const enableStoreLocatorV2 = useFlag('enable-store-locator-v2');
  const params = useLocalSearchParams();

  useForwardToStoreLocator(
    { ...params, tab: StoreLocatorServiceModeTab.PICKUP },
    Boolean(enableStoreLocatorV2)
  );

  if (enableStoreLocatorV2) {
    return <Stack.Screen options={{ headerShown: false, animation: 'none' }} />;
  }

  return (
    <>
      <Head>
        <title>Find a Firehouse - Firehouse Subs</title>
      </Head>
      <VisuallyHiddenH1 title="Store Locator" />
      <StoreLocator />
    </>
  );
}

export default StoreLocatorPage;
